import { render, staticRenderFns } from "./Senha.vue?vue&type=template&id=1bbcd644&scoped=true"
import script from "./Senha.vue?vue&type=script&lang=js"
export * from "./Senha.vue?vue&type=script&lang=js"
import style0 from "@/assets/stylesheets/components/personal-data/Senha.scss?vue&type=style&index=0&id=1bbcd644&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbcd644",
  null
  
)

export default component.exports